import { createSelector } from "reselect";
import { getTaskListsByProjectId } from "./selector.taskLists.jsx";
import { getAllProjectTasksFiltered } from "./selector.tasks.jsx";

export const getGanttTaskLists = createSelector(
  getAllProjectTasksFiltered,
  getTaskListsByProjectId,
  (tasks, taskLists) => {
    let mapValues = tasks
      .filter((t) => t.get(`due_on`) > 0 && t.get(`start_on`) > 0)
      .reduce((a, b) => {
        if (!a[b.get(`task_list_id`)]) {
          a[b.get(`task_list_id`)] = [];
        }

        a[b.get(`task_list_id`)].push(b.get(`id`));

        return a;
      }, {});

    return taskLists
      .filter((taskList) => {
        let mapValue = mapValues[`${taskList.get(`id`)}`];

        return mapValue && mapValue.length > 0;
      })
      .map((taskList) => ({
        id: `task-list-${taskList.get(`id`)}`,
        class: "TaskList",
        original_id: taskList.id,
        text: taskList.get(`name`),
        type: "project",
        name: taskList.get(`name`),
        sortKey: `${taskList.position}`,
        open: true,
        readonly: true,
      }))
      .toArray();
  }
);
